import { createI18n } from "vue-i18n";
import zh from "./zh";
import en from "./en";

// 获取浏览器语言
function getBrowserLanguage() {
  const lang = navigator.language || navigator.userLanguage;
  return lang.startsWith("zh") ? "zh" : "en";
}

// 获取保存的语言
function getSavedLanguage() {
  const savedLang = localStorage.getItem("app-language");
  if (savedLang && ["zh", "en"].includes(savedLang)) {
    return savedLang;
  }
  return getBrowserLanguage();
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getSavedLanguage(), // 初始语言
  fallbackLocale: "en", // 回退语言
  globalInjection: true, // 全局注入 $t 函数
  messages: {
    zh,
    en,
  },
});

export default i18n;
